export default __webpack_public_path__ + "assets/images/b8891b7653095cb9beb8b75700f63705.svg";